import { render } from "./SearchComponent.vue?vue&type=template&id=0c5f65e0"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import "./SearchComponent.vue?vue&type=style&index=0&id=0c5f65e0&lang=scss"
script.render = render

export default script